import { Box, factory, Flex, Link, Tab, Typography } from '@kohler-dsm-library/kohler-core';
import { ArrowRightBoldIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './index.module.scss';

export const OverlayMenuTabs = factory((props, ref) => {
  const { className, title, CTAs, ...rest } = props;

  return (
    <Flex
      ref={ref}
      direction="column"
      gap={10}
      className={clsx(className, 'kohler-overlay-menu-tabs', classes.overlayMenuTabs)}
      {...rest}
    >
      {title && (
        <Typography component="span" size="label-medium-m" textColor="var(--Primary-Carbon, #5D5D5D);">
          {title}
        </Typography>
      )}

      <Flex component="ul" direction="column" gap={0}>
        {CTAs?.map((link) => {
          const { hasChildrenList, ...linkProps } = link;
          return (
            <Box component="li" key={link.text}>
              {hasChildrenList ? (
                <Tab
                  variant="vertical"
                  id={link.text}
                  textColor="var(--content-action-default)"
                  type="button"
                  {...linkProps}
                />
              ) : (
                <Link
                  underline={false}
                  rightIcon={<ArrowRightBoldIcon withBoundingBox={false} size="xSmall" />}
                  className={classes.overlayMenuImageCTA}
                  size="small"
                  href={link.href}
                >
                  {link.text}
                </Link>
              )}
            </Box>
          );
        })}
      </Flex>
    </Flex>
  );
});
